/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * The Agent event type :
 * * CONNECTION : the event is a connection
 * * DISCONNECTION : the event is a disconnection
 * * DATA : the event is a data transfert
 * * ERROR : the event is an error
 */
export enum AgentEventType {
  CONNECTION = 'CONNECTION',
  DISCONNECTION = 'DISCONNECTION',
  DATA = 'DATA',
  ERROR = 'ERROR'
}
